import { Step } from './VerticalProgressBar/index'

export const getStepsData = ({ getRemoteString }): Step[] => {
  return [
    {
      label: getRemoteString({ key: 'registration.moc_feature_lander.step_1.title' }),
      desc: getRemoteString({ key: 'registration.moc_feature_lander.step_1.body' }),
      tooltip: getRemoteString({ key: 'registration.moc_progress_one.step_1.tooltip' }),
    },
    {
      label: getRemoteString({ key: 'registration.moc_feature_lander.step_2.title' }),
      desc: getRemoteString({ key: 'registration.moc_feature_lander.step_2.desc' }),
      tooltip: getRemoteString({ key: 'registration.moc_feature_lander.step_2.tooltip' }),
    },
    {
      label: getRemoteString({ key: 'registration.moc_feature_lander.step_3.title' }),
      desc: getRemoteString({ key: 'registration.moc_feature_lander.step_3.desc' }),
      tooltip: getRemoteString({ key: 'registration.moc_feature_lander.step_3.tooltip' }),
    },
  ]
}
